export default "/_next/static/chunks/fonts/Entypo-9b276936542ea5ccf548bf0e6f505db3.ttf";